// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V11zF","input":"styles_input__64VRl"};